var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{staticClass:"background-color-fire-engine-red-trans color-fire-engine-red text-center"},[_vm._v(" This item contains alcohol. You will be required to show ID to receive this item. ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }